"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const context = react_1.default.createContext({
    leftSidebarPlaceholderRef: react_1.default.createRef(),
    rightSidebarPlaceholderRef: react_1.default.createRef(),
    attachSidebar: () => { },
    detachSidebar: () => { },
    updateSidebar: () => { },
    closeNavigation: () => { },
    closeNavigationMobile: () => { },
    setBreadcrumbs: () => { },
    unsetBreadcrumbs: () => { },
    setTitle: () => { },
    unsetTitle: () => { },
    setBackAction: () => { },
    unsetBackAction: () => { },
});
exports.Provider = context.Provider, exports.Consumer = context.Consumer;
exports.default = context;
